// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zfwBmDHb1AtU3dMHXR4g{width:100%}.sxBFph0aECibw6bOM72I{align-items:flex-start;margin-top:40px}.IZTszsZM4yY5mOeG4hRN{align-items:flex-start;margin-top:24px}.o5qpRtjFngxCUGawTROW{flex-direction:column;gap:16px;display:flex}.gQITX9UaRLkDwrJPFVHO{color:var(--content-primary-tertiary);margin:0;padding-left:23px;list-style:outside}.gQITX9UaRLkDwrJPFVHO li{line-height:15px}.i942JIZ2uuE6zRKtAYY8{margin-left:-3px}.gQITX9UaRLkDwrJPFVHO li::marker{font-size:13px}.VgI1trcTToMwC1m6L_oG{color:var(--content-brand-primary);text-decoration:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `zfwBmDHb1AtU3dMHXR4g`,
	"firstCheckbox": `sxBFph0aECibw6bOM72I`,
	"checkbox": `IZTszsZM4yY5mOeG4hRN`,
	"termsLabel": `o5qpRtjFngxCUGawTROW`,
	"disclosures": `gQITX9UaRLkDwrJPFVHO`,
	"disclosureText": `i942JIZ2uuE6zRKtAYY8`,
	"link": `VgI1trcTToMwC1m6L_oG`
};
export default ___CSS_LOADER_EXPORT___;
